import { Button, Card, Icon, Space, Typography } from '@sravni/react-design-system';
import { Download } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

import { downloadDocument, useAppSelector, useCrossPopup } from 'shared/lib';
import { showNotification } from 'shared/lib/showNotification';

import { selectOfferDocumentsInfoPopup } from 'features/PostIssuanceHelp/model';

import styles from './OfferDocumentsInfoPopup.module.scss';

interface IEarlyRepaymentPopupProps {
  visible: boolean;
  onClose: () => void;
}

export const OfferDocumentsInfoPopup: React.FC<IEarlyRepaymentPopupProps> = ({ visible, onClose }) => {
  const Popup = useCrossPopup();
  const { title, documents, buttons } = useAppSelector(selectOfferDocumentsInfoPopup);
  const isMobile = useIsMobile();

  const download = async (path: string, filename: string) => {
    try {
      await downloadDocument({ path, filename });
    } catch {
      showNotification({ title: 'Не удалось скачать документ' });
    }
  };

  return (
    <Popup
      className={styles.modal}
      visible={visible}
      onClose={onClose}
    >
      <Popup.Header title={title} />

      <Popup.Content>
        <Space
          direction="vertical"
          size={24}
        >
          <Card
            size={16}
            color="dark"
          >
            <Space
              size={24}
              direction="vertical"
            >
              {documents.map((document) => (
                <Space
                  justify="space-between"
                  key={document.title}
                >
                  <Typography.Text size={16}>{document.title}</Typography.Text>

                  {document?.file && (
                    <Typography.Link onClick={() => download(document.file, document.title)}>
                      <Icon icon={<Download />} />
                    </Typography.Link>
                  )}
                </Space>
              ))}
            </Space>
          </Card>

          <Space justify="end">
            {buttons.map((button) => (
              <Button
                onClick={onClose}
                block={isMobile}
                key={button.title}
              >
                {button.title}
              </Button>
            ))}
          </Space>
        </Space>
      </Popup.Content>
    </Popup>
  );
};
